export const pixiAnimationsFlow = (
  isLoading,
  state,
  addShuttle,
  shuttleEngineStartAnimation,
  removeShuttleEnd,
  ticker,
  container,
  // removeShuttle,
  startExplosion,
  // value,
  isError,
  isJackpot,
  jackpotPopup
) => {
  if (isJackpot && !isLoading && !isError) {
    // removeShuttle()
    // removeShuttleEnd();
    !jackpotPopup && shuttleEngineStartAnimation();
    return;
  }
  if (!isLoading && !isError && !isJackpot) {
    if (document.visibilityState === "visible") {
      if (state === 1) {
        removeShuttleEnd();
        addShuttle();
        // startLaunchAnimation()
      }
      if (state === 2) {
        removeShuttleEnd();
        addShuttle();
        shuttleEngineStartAnimation();
      }
      if (state === 3) {
        setTimeout(() => {
          removeShuttleEnd();
        }, 100);
        startExplosion();
      }
    }
  } else {
    removeShuttleEnd();
    !isJackpot && shuttleEngineStartAnimation(ticker, container, true);
  }
};
